import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    examId: null,
    questions: [],
    durationMinutes: 0,
    questionCount: 0,
};

/**
 * Экзамен, который начали. Вопросы приходят одним ответом при создании и хранятся здесь
 * до конца: экзамен фиксирован по определению, и перезапрашивать набор незачем.
 */
const examSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setExam(state, action) {
            return { ...initialState, ...action.payload };
        },
    },
});

export const { setExam } = examSlice.actions;
export default examSlice.reducer;
